import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import { useNavigate } from "react-router";
import icon6 from "../../assets/image/icon6.png"
import { Upload, message, notification } from "antd";
import { showLoding } from "../../utils/tool";
import { validateImageFile } from "../../utils";
import { fileSignedUrl, fileUpload, getUserInfo, userAuthDetail, userAuthSubmit } from "../../API";
import { useSelector } from "react-redux";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const [imageUrl1, setImageUrl1]: any = React.useState<string>("");
  const beforeUpload1 = async (file: any) => {
    const validation = validateImageFile(file);
    if (!validation.isValid) {
      notification.open({
        message: validation.message,
      });
      return false;
    }
    showLoding(true);
    fileUpload({
      file: file,
      bucketAccessLevel: 'PUBLIC'
    })
      .then((res: any) => {
        fileSignedUrl({
          path: res?.data
        }).then((res2: any) => {
          setImageUrl1(res2?.data);
        }).catch((err: any) => {
        })
      })
      .catch((err: any) => {
      })
      .finally(() => {
        showLoding(false);
      });
    return false;
  };
  const [imageUrl2, setImageUrl2]: any = React.useState<string>("");
  const beforeUploa2 = async (file: any) => {
    const validation = validateImageFile(file);
    if (!validation.isValid) {
      notification.open({
        message: validation.message,
      });
      return false;
    } 
    showLoding(true);
    fileUpload({
      file: file,
      bucketAccessLevel: 'PUBLIC'
    })
      .then((res: any) => {
        fileSignedUrl({
          path: res?.data
        }).then((res2: any) => {
          setImageUrl2(res2?.data);
        }).catch((err: any) => {
        })
      })
      .catch((err: any) => {
      })
      .finally(() => {
        showLoding(false);
      });
    return false;
  };
  const [imageUrl3, setImageUrl3]: any = React.useState<string>("");
  const beforeUpload = async (file: any) => {
    const validation = validateImageFile(file);
    if (!validation.isValid) {
      notification.open({
        message: validation.message,
      });
      return false;
    }
    showLoding(true);
    fileUpload({
      file: file,
      bucketAccessLevel: 'PUBLIC'
    })
      .then((res: any) => {
        fileSignedUrl({
          path: res?.data
        }).then((res2: any) => {
          setImageUrl3(res2?.data);
        }).catch((err: any) => {
        })
      })
      .catch((err: any) => {
      })
      .finally(() => {
        showLoding(false);
      });
    return false;
  };

  const [phone, setPhone] = React.useState<string>("");
  const [bankAccountName, setBankAccountName] = React.useState<string>("");
  const [bankName, setBankName] = React.useState<string>("");
  const [branchName, setBranchName] = React.useState<string>("");
  const [bankAccountNumber, setBankAccountNumber] = React.useState<string>("");
  const [walletAddress, setWalletAddress] = React.useState<string>("");
  const handleUserAuthSubmit = () => {
    // if (!imageUrl3) {
    //   message.error("請上傳相關證件");
    //   return
    // }
    showLoding(true);
    userAuthSubmit({
      idCardFrontUrl: imageUrl1,
      idCardBackUrl: imageUrl2,
      "phone": phone,
      "bankAccountName": bankAccountName,
      "bankName": bankName,
      "branchName": branchName,
      "bankAccountNumber": bankAccountNumber,
      "bankAccountPhotoUrl": imageUrl3,
      "walletAddress": walletAddress,
      "submitterName": userInfo?.username,
    }).then((res: any) => {
      message.success("提交成功，請等待審核")
      navigate('/account')
    }).catch((err: any) => {
    }).finally(() => {
      showLoding(false);
    })
  }

  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    if (!token) {
      return
    }
    handleUserInfo()
  }, [token]);

  const [userInfo, setUserInfo]: any = React.useState({});
  const handleUserInfo = () => {
    getUserInfo().then((res) => {
      setUserInfo(res.data);
      if (res.data?.enableShop) {
        handleUserAuthDetail()
      }
    }).catch((err) => {
    });
  }

  const handleUserAuthDetail = () => {
    userAuthDetail().then((res) => {
      setPhone(res.data?.phone);
      setBankAccountName(res.data?.bankAccountName);
      setBankName(res.data?.bankName);
      setBranchName(res.data?.branchName);
      setBankAccountNumber(res.data?.bankAccountNumber);
      setWalletAddress(res.data?.walletAddress);
      setImageUrl1(res.data?.idCardFrontUrl);
      setImageUrl2(res.data?.idCardBackUrl);
      setImageUrl3(res.data?.bankAccountPhotoUrl);
    }).catch((err) => {
    })
  }
  return (
    <div className="">
      <TopBar /> 
      <div className="w-[960px] mx-auto h5:w-full h5:px-[16px]">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4 cursor-pointer" onClick={() => navigate('/account')}>會員中心</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">會員認證</div>
        </div>
        <br />
        <div className="mb-20 rounded-[8px] py-[10px] px-[20px] hidden"
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}>
          <div className="text-[181512] text-[18px] font-bold pt-10 pb-10">身份證資訊</div>
          <div className="flex items-end mb-20 h5:block">
            <div className="flex-1 pr-10 h5:pr-0">
              <div className="bg-[#fff] py-[20px] px-[20px] rounded-[8px] h5:mb-10">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  showUploadList={false}
                  action=""
                  beforeUpload={beforeUpload1}
                  className="imgUpload"
                  maxCount={1}
                >
                  {
                    imageUrl1 ?
                      <img src={imageUrl1}
                        className="w-auto h-[160px] object-cover rounded-[8px]"
                        alt="" />
                      :
                      <img src={require("../../assets/image/icon28.png")}
                        className="w-auto h-[160px] object-cover rounded-[8px]"
                        alt="" />
                  }
                </Upload> 
              </div>
            </div>
            <div className="flex-1 pl-10 h5:pl-0">
              <div className="bg-[#fff] py-[20px] px-[20px] rounded-[8px]">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  showUploadList={false}
                  action=""
                  beforeUpload={beforeUploa2}
                  className="imgUpload"
                  maxCount={1}
                >
                  {
                    imageUrl2 ?
                      <img src={imageUrl2}
                        className="w-auto h-[160px] object-cover rounded-[8px]"
                        alt="" />
                      :
                      <img src={require("../../assets/image/icon29.png")}
                        className="w-auto h-[160px] object-cover rounded-[8px]"
                        alt="" />
                  }
                </Upload>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-20  rounded-[8px] py-[10px] px-[20px]"
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}>
          <div className="text-[181512] text-[18px] font-bold pt-10 pb-20">手機號碼驗證</div>
          <div className="flex items-center mb-[20px]">
            <div className="flex items-center text-[#181512] text-[18px] w-[92px]">
              手機號碼
              {/* <div className="text-[red] text-[18px] mr-10">*</div> */}
            </div>
            <input type="text"
              placeholder="請輸入手機號碼"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="flex-1 px-[15px] py-[10px] rounded-[8px] outline-none text-[#181512] text-[18px]"
              style={{
                border: "1px solid #cfc8d8",
              }}
            />
          </div>
        </div>
        <div className="mb-20 rounded-[8px] py-[10px] px-[20px]"
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}
        >
          <div className="text-[181512] text-[18px] font-bold pt-10 pb-20">銀行帳戶資訊</div>
          <div className="flex items-center mb-[20px]">
            <div className="flex items-center text-[#181512] text-[18px] w-[92px]">
              戶名
              {/* <div className="text-[red] text-[18px] mr-10">*</div> */}
            </div>
            <input type="text"
              placeholder="請輸入銀行戶名"
              value={bankAccountName}
              onChange={(e) => setBankAccountName(e.target.value)}
              style={{
                border: "1px solid #cfc8d8",
              }}
              className="flex-1 px-[15px] py-[10px] rounded-[8px] outline-none text-[#181512] text-[18px]" />
          </div>
          <div className="flex items-center mb-[20px]">
            <div className="flex items-center text-[#181512] text-[18px] w-[92px]">
              銀行名稱
              {/* <div className="text-[red] text-[18px] mr-10">*</div> */}
            </div>
            <input type="text"
              placeholder="請輸入銀行名稱"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              style={{
                border: "1px solid #cfc8d8",
              }}
              className="flex-1 px-[15px] py-[10px] rounded-[8px] outline-none text-[#181512] text-[18px]" />
          </div>
          <div className="flex items-center mb-[20px]">
            <div className="flex items-center text-[#181512] text-[18px] w-[92px]">
              分行名稱
              {/* <div className="text-[red] text-[18px] mr-10">*</div> */}
            </div>
            <input type="text"
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
              placeholder="請輸入分行名稱"
              style={{
                border: "1px solid #cfc8d8",
              }}
              className="flex-1 px-[15px] py-[10px] rounded-[8px] outline-none text-[#181512] text-[18px]" />
          </div>
          <div className="flex items-center mb-[20px]">
            <div className="flex items-center text-[#181512] text-[18px] w-[92px]">
              銀行帳號
              {/* <div className="text-[red] text-[18px] mr-10">*</div> */}
            </div>
            <input type="text"
              value={bankAccountNumber}
              onChange={(e) => setBankAccountNumber(e.target.value)}
              placeholder="請輸入銀行帳號"
              style={{
                border: "1px solid #cfc8d8",
              }}
              className="flex-1 px-[15px] py-[10px] rounded-[8px] outline-none text-[#181512] text-[18px]" />
          </div>
          <div className="flex items-end mb-20">
            <div className="flex-1">
              <div className="bg-[#fff] py-[20px] px-[20px] rounded-[8px]">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  showUploadList={false}
                  action=""
                  beforeUpload={beforeUpload}
                  className="imgUpload"
                  maxCount={1}
                >
                  {
                    imageUrl3 ?
                      <img src={imageUrl3}
                        className="w-auto h-[160px] object-cover rounded-[8px]"
                        alt="" />
                      :
                      <img src={require("../../assets/image/icon30.png")}
                        className="w-auto h-[160px] object-cover rounded-[8px]"
                        alt="" />
                  }
                </Upload>
              </div>
            </div>
          </div>
          <div className="mb-20 bg-[#f6f5f1] rounded-[8px] py-[10px] px-[20px]">
            <div className="text-[181512] text-[18px] font-bold pt-10 pb-20">區塊鏈錢包地址</div>
            <div className="flex items-center mb-[20px]">
              <div className="flex items-center text-[#181512] text-[18px] w-[150px]">
                USDT (TRC20)
                {/* <div className="text-[red] text-[18px] mr-10">*</div> */}
              </div>
              <input type="text"
                value={walletAddress}
                onChange={(e) => setWalletAddress(e.target.value)}
                placeholder="請輸入 USDT TRC20 地址"
                style={{
                  border: "1px solid #cfc8d8",
                }}
                className="flex-1 px-[15px] py-[10px] rounded-[8px] outline-none text-[#181512] text-[18px]" />
            </div>
          </div>
          <div className="flex justify-center mb-20">
            <div
              onClick={() => handleUserAuthSubmit()}
              className="bg-[#6d6e71] rounded-[4px] inline-block px-[80px] 
            py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]">
              提交認證
            </div>
          </div>
        </div>
      </div>
      <br /> <br /> <br />
    </div>
  );
};

export default ComponentName;
